import { hasProperty } from "@/js/utils";

export default {
  methods: {
    /**
     * 削除権限があるか（レコード単位でチェック）
     * @param item
     * @param hasNotAuthority
     * @returns {boolean}
     */
    hasDeleteAuthorityByItem(item, hasNotAuthority = false) {
      if (hasNotAuthority === true) {
        // hasNoAuthorityがtureなら最優先で権限なしと判定する
        return false;
      }
      if (!hasProperty(item, "authcheck")) {
        return false;
      }
      // 111:参照権限あり 操作権あり 削除権限あり
      return item.authcheck === "111";
    },
    /**
     * 更新権限があるか（レコード単位でチェック）
     * @param item
     * @param hasNotAuthority
     * @returns {boolean|*}
     */
    hasUpdateAuthorityByItem(item, hasNotAuthority = false) {
      if (hasNotAuthority === true) {
        // hasNoAuthorityがtureなら最優先で権限なしと判定する
        return false;
      }
      if (!hasProperty(item, "authcheck")) {
        return false;
      }
      // 111:参照権限あり 操作権あり 削除権限あり
      // 110:参照権限あり 操作権あり 削除権限なし
      return ["111", "110"].includes(item.authcheck);
    }
  }
};
